var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"main-layout"}},[_c('app-bar',{attrs:{"dense":"","dark":"","color":"primary"}}),_c('v-main',[_c('div',{staticClass:"px-10",attrs:{"id":"flex-row"}},[_c('v-card',{attrs:{"id":"main-content"}},[_vm._t("default")],2)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }